import React from "react";

const SvgConstructPurpleMugShot = ({ size = 77, floatType = "none" }) => {
  return (
    <svg
      viewBox="0 0 77 77"
      width={size}
      height={size}
      style={{ float: floatType }}
    >
      <ellipse
        cx="38.4837"
        cy="38.6533"
        rx="37.5"
        ry="37.5"
        fill="#9555E6"
        fillOpacity="0.1"
        stroke="#9555E6"
      ></ellipse>
      <path
        d="M36.9838 36.6533C34.4994 36.6533 32.3666 35.7861 30.5853 34.0518C28.851 32.2705 27.9838 30.1377 27.9838 27.6533C27.9838 25.1689 28.851 23.0361 30.5853 21.2549C32.3666 19.5205 34.4994 18.6533 36.9838 18.6533C39.4681 18.6533 41.601 19.5205 43.3822 21.2549C45.1166 23.0361 45.9838 25.1689 45.9838 27.6533C45.9838 30.1377 45.1166 32.2705 43.3822 34.0518C41.601 35.7861 39.4681 36.6533 36.9838 36.6533ZM40.5697 40.0283C43.8978 40.0283 46.7572 41.2236 49.1478 43.6143C51.5385 46.0049 52.7338 48.8643 52.7338 52.1924C52.7338 53.833 51.9135 54.6533 50.2728 54.6533H23.6947C22.0541 54.6533 21.2338 53.833 21.2338 52.1924C21.2338 48.8643 22.4291 46.0049 24.8197 43.6143C27.2103 41.2236 30.0697 40.0283 33.3978 40.0283H40.5697Z"
        fill="#9555E6"
      ></path>
    </svg>
  );
};

export default SvgConstructPurpleMugShot;
